import { Button, TextField, TextFieldProps, Typography } from "@mui/material";
import React, { useContext } from "react";
import { format, parseISO } from "date-fns";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Close } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import LectureListContext from "../../contexts/LectureListContext";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const DatePickerButton = () => {
    const { date, setDate } = useContext(LectureListContext);
    const [open, setOpen] = React.useState(false);

    const onChange = (selectedDate: Date | null) => {
        if (selectedDate) {
            setDate(format(selectedDate, "yyyy-MM-dd"));
        }
        setOpen(false);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Button
                variant="contained"
                onClick={() => setOpen(true)}
                sx={{
                    height: "45px",
                    borderRadius: "50px",
                    backgroundColor: "#006E94",
                    flexGrow: 1,
                    justifyContent: "space-between",
                    padding: "0 16px",
                    "&:hover": {
                        backgroundColor: "#006E94"
                    }
                }}
            >
                <Typography variant="body1" color="#F1EEDB" fontWeight={700}>
                    {date ? format(parseISO(date), "yyyy/MM/dd") : "اختر تاريخ"}
                </Typography>
                
                {date && (
                    <Close
                        sx={{ 
                            color: "#F1EEDB",
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 }
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setDate("");
                        }}
                    />
                )}
            </Button>

            <DatePicker
                open={open}
                onClose={() => setOpen(false)}
                value={date ? parseISO(date) : null}
                onChange={onChange}
                slots={{ textField: TextField }}
                slotProps={{
                    textField: {
                        sx: { display: "none" },
                    } as TextFieldProps,
                    dialog: {
                        sx: {
                            "& .MuiDialog-paper": {
                                color: "black",
                            },
                        },
                    },
                    actionBar: {
                        actions: ["clear", "cancel", "accept"],
                        sx: {
                            "& .MuiButton-root": {
                                color: "black",
                            },
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default DatePickerButton;
